import { h, Component } from 'preact';
import { Text } from 'preact-i18n';
import { route } from 'preact-router';
import { observer } from 'mobx-preact';

import { faceRecognitionEnabled } from '../../lib/faceConsent';

/*
 * "Photos of me" tile for the profile page's navigation grid.
 *
 * This lives in a component rather than inline in routes/users/profile.js
 * because profile.js is SHARED with the Dyrejournal build, while /my-photos,
 * the /api/faces/* mounts and lib/faceConsent.js are all stripped from it.
 * Inlining the tile there would either break that build's import graph or
 * render a tile routing to a page that does not exist. Reached only through
 * the components-other registry, exactly like ProfileFaceConsent.
 *
 * Unlike its neighbours in that grid, this tile NAVIGATES instead of switching
 * the profile page's `view` — the matches live on their own route.
 */
@observer
class ProfileMyPhotosTile extends Component {
    gotoMyPhotos = () => {
        route('/my-photos');
    }

    render() {
        const { stores, darkmode } = this.props;
        const { appState } = stores;

        // Second gate, matching ProfileFaceConsent: no tenant sees this unless
        // face recognition is provisioned and switched on for them. The page
        // itself and the server both re-check; this only keeps the tile out of
        // the grid where the feature is off.
        if (!faceRecognitionEnabled(appState?.currentCustomer)) {
            return null;
        }

        return (
            <div
                class={`d-flex flex-column align-items-center px-1 py-3 box-container ${darkmode ? 'bg-darkmode' : 'bg-lightmode'}`}
                style='flex: 1 1 calc(25% - 0.5rem); min-width: 70px;'
                onClick={this.gotoMyPhotos}
            >
                <span style='font-size: 1.5rem;'>
                    <i class='fa-duotone fa-images-user' />
                </span>
                <small class='text-center font-style-narrow'>
                    <Text id='menu.my-photos'>Photos of me</Text>
                </small>
            </div>
        );
    }
}

export default ProfileMyPhotosTile;
